<template>
    <div class="home"  id="homeBox">
        <!--    左侧-->



        <logicflow ref="logicflow"  > </logicflow>


    </div>


</template>

<script>

    import logicflow from "@/views/flowManage/flow/logicflow";

    export default {
        name: "flowManage",
        components: {

            logicflow,
        },

        data() {
            return {};
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        mounted() {
            this.onResize();

        },
        methods: {

            onResize(n) {
                if (n == undefined) n = this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);

            },
        }
    }




</script>


<style lang="scss" >

    .home {
        margin-top: 0px;
        height: 100%;
        width: 100%;



    }







</style>

